"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenteredColumnContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const columnSidePaddingValues = {
    xs: "16px",
    md: "24px",
    lg: "40px",
    xl: "80px",
};
exports.CenteredColumnContainer = styled_components_1.default.div `
  max-width: 1280px;
  margin: 0 auto;
  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "padding-left",
    values: columnSidePaddingValues,
})}

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "padding-right",
    values: columnSidePaddingValues,
})}
`;
//# sourceMappingURL=styles.js.map